import React, {Component} from "react";
import {connect} from "react-redux";
import SubscriptionItem from "./SubscriptionItem";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import Loading from "../../components/Loading";
import GraphQLErrors from "../../components/GraphQLErrors";
import EmptyStatus from "../../components/EmptyStatus";
import Conditional from "../../components/Conditional";
import {fromJS} from "immutable";
import {ACCOUNT_SUBSCRIPTIONS} from "../../queries/customers";
import {
  requestChangeSubscriptionFrequency, 
  requestChangeSubscriptionQuantity, 
  requestChangeSubscriptionShippingAddress,
  requestChangeSubscriptionProducts,
  requestViewSubscriptionLog,
  requestViewSubscriptionDelivery,
  requestRescheduleSubscriptionDelivery,
  requestPauseSubscription,
  requestResumeSubscriptionScheduling,
  requestCancelSubscription,
  requestRestartSubscription,
  requestRenameSubscription } from "../../actions/AccountApiActions";
import {showContextualMenu} from "../../actions/ViewActions";
import {ON_ACCOUNT_SUBSCRIPTIONS_UPDATED} from "../../queries/sales";
import "./SubscriptionList.css";

function maybeFilterCancelledSubscriptions(shouldFilter, subscriptions) {
  if (shouldFilter === false) return subscriptions;
  // reject subscriptions that are cancelled.
  return subscriptions.filter((sub) => sub.get("status") !== "cancelled");
}

class SubscriptionList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      showCancelled: false
    }
  }

  UNSAFE_componentWillMount() {
    this.props.subscribeToAccountSubscriptionsUpdates(this.props, {}); 
  }  

  handleShowCancelledSubscriptions() {
    this.setState({showCancelled: !this.state.showCancelled});
  }

  render() {
    let {loading, error} = this.props.data;
    if (loading) return <Loading />
    if (error) return <GraphQLErrors error={error} />
    let subscriptions = fromJS(this.props.data.accountSubscriptions);
    if (subscriptions.size === 0) {
      return <EmptyStatus status="No subscriptions found" />
    }

    let subscriptionElements = maybeFilterCancelledSubscriptions(!this.state.showCancelled, subscriptions).map(x => {
      return <SubscriptionItem 
                key={x.get("subscriptionId")}
                subscription={x} 
                onChangeSubscriptionFrequency={this.props.requestChangeSubscriptionFrequency}
                onChangeSubscriptionQuantity={this.props.requestChangeSubscriptionQuantity} 
                onChangeSubscriptionProducts={this.props.requestChangeSubscriptionProducts} 
                onChangeSubscriptionShippingAddress={this.props.requestChangeSubscriptionShippingAddress} 
                onViewSubscriptionLog={this.props.requestViewSubscriptionLog}
                onSelectDelivery={this.props.requestViewSubscriptionDelivery} 
                onRescheduleDelivery={this.props.requestRescheduleSubscriptionDelivery} 
                onPause={this.props.requestPauseSubscription}
                onUndoPause={this.props.requestResumeSubscriptionScheduling}
                onUndoCancel={this.props.requestResumeSubscriptionScheduling}
                onCancel={this.props.requestCancelSubscription} 
                onRestart={this.props.requestRestartSubscription}
                onRename={this.props.requestRenameSubscription}
                onShowContextualMenu={this.props.showContextualMenu} />
    })

    let cancelledSubscriptionsCount = subscriptions.size - subscriptionElements.size;

    return (
      <div className="SubscriptionList">
        <Conditional show={!this.state.showCancelled && cancelledSubscriptionsCount > 0}>
          <p className="revealCancelledSubscriptions" onClick={this.handleShowCancelledSubscriptions.bind(this)}>
            Hiding <span>{cancelledSubscriptionsCount}</span> cancelled subscriptions. Click to show all.
          </p>
        </Conditional>
        <div className="list">
          {subscriptionElements}
        </div>
        <p className="disclaimer">Prices do not include sales tax</p>
      </div>
    )
  }
}

SubscriptionList.defaultProps = {
  accountId: ""
}

const withQuery = compose(
  graphql(ACCOUNT_SUBSCRIPTIONS, {
    options: (props) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        accountId: props.accountId
      }
    })
  })
)

const mapDispatchToProps = dispatch => ({
  subscribeToAccountSubscriptionsUpdates: (props, params) => {
    return props.data.subscribeToMore({
      document: ON_ACCOUNT_SUBSCRIPTIONS_UPDATED,
      variables: {
        accountId: props.accountId
      },
      updateQuery: (prev, { subscriptionData }) => {
        props.data.refetch();
        return prev;
      }
    })
  }
})

const withSubscription = connect(null, mapDispatchToProps);


export default connect(null, {
  requestChangeSubscriptionFrequency,
  requestChangeSubscriptionQuantity,
  requestChangeSubscriptionProducts,
  requestChangeSubscriptionShippingAddress,
  requestViewSubscriptionLog,
  requestViewSubscriptionDelivery,
  requestRescheduleSubscriptionDelivery,
  requestPauseSubscription,
  requestResumeSubscriptionScheduling,
  requestCancelSubscription,
  requestRestartSubscription,
  requestRenameSubscription,
  showContextualMenu
})(withQuery(withSubscription(SubscriptionList)));
